export const IDLE_CAFE_IOS_URL =
  'https://apps.apple.com/gb/app/idle-caf%C3%A9/id6807791240';

export const IDLE_CAFE_ANDROID_URL =
  'https://play.google.com/store/apps/details?id=com.aquaristltd.idlecafe';
